module.exports = __webpack_public_path__ + "img/MTL-alt.cc5c6858.svg";